module.exports = __webpack_public_path__ + "media/images/ogp-4020aca0b44bcf7f8566b4f10f167f59.png";